(function(){
  'use strict';


  function disableMobilePopups(){
    if(document.getElementById('fh-disable-mobile-popups-css')) return;
    var style = document.createElement('style');
    style.id = 'fh-disable-mobile-popups-css';
    style.textContent = '@media (max-width:768px){.fh-lead-modal,.fh-email-popup,.newsletter-popup,.popup-modal[class*=newsletter],[class*=klaviyo][class*=popup],[class*=klaviyo][class*=modal]{display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;}}';
    document.head.appendChild(style);
  }

  function injectPopupStyles(){
    if(document.getElementById('fh-popup-mobile-polish-css')) return;
    var style = document.createElement('style');
    style.id = 'fh-popup-mobile-polish-css';
    style.textContent = [
      '.fh-email-popup [class*=recommend],.fh-email-popup [class*=product],.fh-email-popup [class*=upsell],.fh-email-popup .fake-order,.fh-email-popup .product-list,.fh-email-popup .mini-cart,.fh-email-popup .cart-items{display:none!important;}',
      '.fh-email-popup button[type=submit],.fh-email-popup input[type=submit]{background:#090909!important;color:#fff!important;border:0!important;font-weight:950!important;text-transform:uppercase!important;letter-spacing:.04em!important;}',
      '@media (max-width:768px){.fh-lead-modal{padding:10px!important;place-items:end center!important;background:rgba(0,0,0,.58)!important;}.fh-lead-card,.fh-email-popup{width:min(430px,96vw)!important;max-height:76vh!important;overflow:auto!important;border-radius:18px 18px 0 0!important;display:block!important;}.fh-lead-image,.fh-email-popup img{max-height:150px!important;aspect-ratio:16/9!important;overflow:hidden!important;}.fh-lead-image img,.fh-email-popup img{width:100%!important;height:100%!important;object-fit:cover!important;}.fh-lead-copy,.fh-email-popup form{padding:18px!important;}.fh-lead-title,.fh-email-popup h2,.fh-email-popup .title{font-size:28px!important;line-height:1.05!important;margin-bottom:10px!important;}.fh-lead-copy p,.fh-email-popup p{font-size:14px!important;line-height:1.35!important;margin-bottom:12px!important;}.fh-lead-form{gap:9px!important;margin:12px 0!important;}.fh-lead-form input,.fh-lead-form button,.fh-email-popup input[type=email],.fh-email-popup button[type=submit],.fh-email-popup input[type=submit]{height:50px!important;min-height:50px!important;width:100%!important;font-size:15px!important;}.fh-lead-pills{gap:6px!important;}.fh-lead-pills li{font-size:11px!important;padding:7px 9px!important;}.fh-lead-close{right:10px!important;top:10px!important;width:36px!important;height:36px!important;font-size:24px!important;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function optimizeEmailPopups(){
    var emailInputs = document.querySelectorAll('input[type="email"], input[name*="email" i]');
    for(var i=0;i<emailInputs.length;i++){
      var input = emailInputs[i];
      var popup = input.closest('.fh-lead-card,.newsletter-popup,.popup,.popup-modal,[class*="newsletter"][class*="popup"],[class*="Popup"],[id*="Popup"],.modal');
      if(!popup || !popup.querySelector('input[type="email"], input[name*="email" i]')) continue;
      popup.classList.add('fh-email-popup');
      var buttons = popup.querySelectorAll('button[type="submit"], input[type="submit"], form button');
      for(var b=0;b<buttons.length;b++){
        if(buttons[b].tagName === 'INPUT') buttons[b].value = 'Send Code';
        else buttons[b].textContent = 'Send Code';
      }
    }
  }

  function init(){
    disableMobilePopups();
  injectPopupStyles();
    optimizeEmailPopups();
    if(!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches){
    setTimeout(optimizeEmailPopups, 800);
    setTimeout(optimizeEmailPopups, 2200);
  }
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  window.addEventListener('load', init, {once:true});
  document.addEventListener('shopify:section:load', init);
})();